import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export function PainSection() {
  return <section className="w-full bg-[#FAFAF5] text-[#0F1B2D] py-24 px-6 md:px-12" data-id="element-162">
      <div className="max-w-3xl mx-auto" data-id="element-163">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-164">
          <h2 className="text-sm font-bold tracking-widest text-[#E8722A] uppercase mb-4 text-center" data-id="element-165">
            The quiet problem nobody says out loud
          </h2>

          <div className="space-y-8 text-xl md:text-2xl leading-relaxed font-medium text-gray-800" data-id="element-166">
            <p data-id="element-167">You're not lazy. You're not "bad at business."</p>

            <p data-id="element-168">
              You're stuck in the worst place: you're willing to do the work…{' '}
              <span className="bg-orange-100 px-1" data-id="element-169">
                but you don't know what the work is.
              </span>
            </p>

            <p data-id="element-170">
              So you scroll. You watch "UGC creators" talk in circles. You save
              videos. You promise yourself you'll start "this weekend."
            </p>

            <p data-id="element-171">
              Then Monday shows up. Bills show up. Life shows up. And you're
              back to: <em data-id="element-172">"I'll start when I feel ready."</em>
            </p>

            <p className="font-bold text-[#0F1B2D]" data-id="element-173">
              You already know how that ends.
            </p>

            <hr className="border-gray-300 my-12 w-24 mx-auto" data-id="element-174" />

            <p data-id="element-175">Here's the truth:</p>

            <p data-id="element-176">
              Brands don't pay you for being famous. They pay you for making
              usable videos that help them sell.
            </p>

            <p className="text-2xl md:text-3xl font-bold text-[#0F1B2D]" data-id="element-177">
              UGC is not an influencer game. It's a deliverables game.
            </p>

            <p data-id="element-178">
              And beginners can win fast—if they stop doing the two things that
              keep them broke:
            </p>

            <ul className="list-disc pl-6 space-y-2 marker:text-[#E8722A]" data-id="element-179">
              <li data-id="element-180">waiting to be discovered</li>
              <li data-id="element-181">overthinking what to create</li>
            </ul>
          </div>
        </motion.div>
      </div>
    </section>;
}